// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
require('./input.scss');
require('./textarea.scss');
require('./button.scss');
require('./checkbox.scss');

const deps = [
  require('./datePicker').name,
  require('./input').name,
  require('./textarea').name,
  require('./checkbox').name,
  require('./select').name,
];

module.exports = angular.module('bench.ui.form', deps);
